/**
 * Actions module loader
 * Lazily loads all action files when initActions() is called
 */

// Re-export the createAction utility
export * from 'utils/actions.js';

/**
 * Initialize the actions system by loading all action modules
 * @returns {Promise<void>}
 */
export async function initActions() {
  // Lazy import every .js file in this folder and subdirectories so their createAction calls run.
  // Excludes index.js and test files using negative glob patterns.
  const modules = import.meta.glob(['./**/*.js', '!./**/*.test.js', '!./index.js']);
  
  // Load all modules
  const loadedModules = await Promise.all(
    Object.entries(modules).map(async ([filePath, importFn]) => {
      const module = await importFn();
      return [filePath, module];
    })
  );
  
  // Inject directory context into each module
  for (const [filePath, module] of loadedModules) {
    const dirPath = filePath.substring(2, filePath.lastIndexOf('/')); // Remove './' and filename
    const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
    
    // Extract category from directory path (e.g., 'project/graph' -> ['project', 'graph'])
    const category = dirPath ? dirPath.split('/').filter(Boolean) : [];
    
    // If the module exports a set function, use it to set the category
    if (typeof module?.default?.set === 'function') {
      module.default.set('category', category);
    }
  }
  
  console.log('Actions initialized');
}

// Hot reload handling - clear actions state if needed
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    // Actions themselves don't need clearing, but this ensures clean reload
    console.log('Actions module hot reloaded');
  });
}